export const READ_CONTACTS = async () => {
  return false
}

export const WRITE_EXTERNAL_STORAGE = async () => {
  return true
}

export const POST_NOTIFICATIONS = async () => {
  return false
}

export const DeviceShare = async (shareOptions: any) => {
  try {
    if (!navigator.canShare) {
      console.log("Your browser doesn't support the Web Share API")
      return
    }
    await navigator.share(shareOptions)
  } catch (err) {
    console.log('share error', err)
  }
}

export const openFileOnDevice = (path, setMessage) => {
  console.log('openFileOnDevice ~ setMessage:', setMessage)
  window.open(path ?? '', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
}
